module.exports = __webpack_public_path__ + "img/top-logo.be8c2059.png";